/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', function () {
    const checkboxes = document.querySelectorAll('.product-checkbox');
    const addToCartButton = document.getElementById('add-to-cart');    
    let selectedProducts = new Map(); 
    let selectedPrice = 0;
    
  
  checkboxes.forEach(checkbox => {
      const input = checkbox.closest('quick-add-product').querySelector('.quantity__input');
      input.addEventListener('change', (e) => {
e.preventDefault();
        let val = input.value;
        checkbox.dataset.quantity = val;
      })

      checkbox.addEventListener('change', function () {
        //const value = checkbox.closest('quick-add-product').querySelector('.quantity__input').value;
        //console.log('Value', value)
        let v = Number(checkbox.dataset.quantity);
        const productId = this.dataset.productId;
        const productPrice = this.dataset.productPrice;
        if (this.checked) {
          selectedProducts.set(productId, {
            quantity: v,
            price: Number(productPrice)
          });
          selectedPrice += Number(productPrice) * v;
        } else {
          if (selectedProducts.has(productId)) {
            const item = selectedProducts.get(productId);
            selectedPrice -= item.price * item.quantity;
            selectedProducts.delete(productId);
          }
        }

        if (selectedPrice > 0) {
          addToCartButton.querySelector('.btn__text').textContent = `Buy ${selectedProducts.size} together for $${selectedPrice / 100}`;
        } else {
          addToCartButton.querySelector('.btn__text').textContent = 'SELECT PRODUCTS TO BUY TOGETHER';
        }
      });
    });

    
    
  
    addToCartButton.addEventListener('click', function () {
      
      if (selectedProducts.size) {
        const formData = {
          items: Array.from(selectedProducts, ([id, item]) => ({
            id: id,
            quantity: item.quantity
          }))
        };
        console.log(formData)
  
        addToCart(formData);
      }
    });
  
    function addToCart(formData) {
      addToCartButton.classList.add('is-loading');
      addToCartButton.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(response => response.json())
        .then(data => {
          addToCartButton.classList.remove('is-loading');
          addToCartButton.classList.add('is-added');
          document.dispatchEvent(
            new CustomEvent('theme:cart:custom')
          );
          
          setTimeout(() => {
            addToCartButton.disabled = false;
            addToCartButton.classList.remove('is-added');
          }, 1000);
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
        });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



document.querySelectorAll('.tabs_inner_reviews li').forEach(tab => {
  tab.addEventListener('click', () => {
    let selectedTab = tab.getAttribute('data-tab');
    
    document.querySelectorAll('.testimonial-card').forEach(card => {
      if (selectedTab === 'All' || card.getAttribute('data-tab-content') === selectedTab) {
        card.style.display = 'block';
      } else {
        card.style.display = 'none';
      }
    });

    document.querySelectorAll('.tabs_inner_reviews li').forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
  });
});

